import { useEffect, useState } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { adminBackendApi } from '@/lib/api/admin-backend'

interface AdminAuthState {
  isAuthenticated: boolean
  isLoading: boolean
  adminUser: unknown | null
}

export function AdminGuard() {
  const [authState, setAuthState] = useState<AdminAuthState>({
    isAuthenticated: false,
    isLoading: true,
    adminUser: null,
  })
  const location = useLocation()

  useEffect(() => {
    const checkAdminAuth = async () => {
      try {
        const session = await adminBackendApi.auth.getSession()
        setAuthState({
          isAuthenticated: !!session.user,
          isLoading: false,
          adminUser: session.user,
        })
      } catch {
        setAuthState({
          isAuthenticated: false,
          isLoading: false,
          adminUser: null,
        })
      }
    }

    checkAdminAuth()
  }, [])

  if (authState.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white dark:bg-[#020617]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-600 dark:text-gray-400">Verifying admin access...</p>
        </div>
      </div>
    )
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />
  }

  return <Outlet context={{ adminUser: authState.adminUser }} />
}
